// extracted by mini-css-extract-plugin
export default {"title":"gallery_title__thMny","link":"gallery_link__NwruH","card":"gallery_card__Ix9KS"};